import styled from 'styled-components';

export const Container = styled.div`
    > p {
        font-size: 14px;
        line-height: 21px;
        color: var(--color-text);
    }
`;
